import { useRef } from "react";
import { Camera, Image as ImageIcon, X, Plus } from "lucide-react";

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// Captura/sube una o varias fotos -> arreglo de data URLs base64
export function PhotoCapture({ value = [], onChange, label = "Fotografías", single = false, testid = "photo" }) {
  const cameraInputRef = useRef(null);
  const galleryInputRef = useRef(null);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const encoded = await Promise.all(files.map(fileToBase64));
    if (single) onChange([encoded[0]]);
    else onChange([...(value || []), ...encoded]);
    e.target.value = "";
  };

  const remove = (idx) => onChange(value.filter((_, i) => i !== idx));

  return (
    <div className="space-y-2">
      {label && <p className="text-sm font-medium text-navy">{label}</p>}
      <div className="flex flex-wrap gap-3">
        {(value || []).map((src, idx) => (
          <div key={idx} className="relative w-24 h-24 border border-border overflow-hidden group rounded-md shadow-sm">
            <img src={src} alt={`foto-${idx}`} className="w-full h-full object-cover" />
            <button
              type="button"
              data-testid={`${testid}-remove-${idx}`}
              onClick={() => remove(idx)}
              className="absolute top-0 right-0 bg-critical text-white p-1 opacity-90 hover:opacity-100 transition-opacity"
            >
              <X size={14} />
            </button>
          </div>
        ))}

        {(!single || (value || []).length === 0) && (
          <div className="flex gap-2">
            {/* Botón Cámara */}
            <button
              type="button"
              data-testid={`${testid}-camera-button`}
              onClick={() => cameraInputRef.current?.click()}
              className="w-24 h-24 border border-dashed border-navy/40 flex flex-col items-center justify-center gap-1 text-navy hover:bg-navy/5 transition-colors rounded-md bg-white shadow-sm"
              title="Tomar Foto"
            >
              <Camera size={24} />
              <span className="text-[10px] font-bold uppercase">Cámara</span>
            </button>

            {/* Botón Galería */}
            <button
              type="button"
              data-testid={`${testid}-gallery-button`}
              onClick={() => galleryInputRef.current?.click()}
              className="w-24 h-24 border border-dashed border-navy/40 flex flex-col items-center justify-center gap-1 text-navy hover:bg-navy/5 transition-colors rounded-md bg-white shadow-sm"
              title="Cargar de Galería"
            >
              <ImageIcon size={24} />
              <span className="text-[10px] font-bold uppercase">Galería</span>
            </button>
          </div>
        )}
      </div>

      {/* Input oculto para Cámara */}
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleFiles}
        className="hidden"
      />

      {/* Input oculto para Galería */}
      <input
        ref={galleryInputRef}
        type="file"
        accept="image/*"
        multiple={!single}
        onChange={handleFiles}
        className="hidden"
      />
    </div>
  );
}
